import { Stack, Button, Divider } from "@mui/material"
import { useContext } from "react"
import UserContext from "../../services/Context/UserContext"
import { useState } from "react"
import Layout from "../Frames/Layout"
import General from "./components/General"
import Location from "./components/Location"
import Pro from "./components/Pro"
import Checkbox from "../Inputs/Checkbox";
import { Link } from "react-router-dom"
import Tester from "../../services/Tester"
import API from "../../services/API"
import { LoadingButton } from "@mui/lab"
import { Error, Success } from "../Tools/Alerts"
import { useEffect } from "react"
import professions from '../../config/status.json'
import Top from "./components/Top"
import Toggle from "../Inputs/Toggle"
import Password from "../Inputs/Password"
import { txt } from "../../services/translation"

export default function Profile(){

    const {user, setUser} = useContext(UserContext)

    const [data, setData] = useState(null)

    const [status, setStatus] = useState('ready')

    const statusIs = s => s === status

    const [errors, setErrors] = useState({})

    useEffect(() => {

        let copy = {...user};

        copy.status = professions.find(s => s.category === user.category?.id && s.id === user.status?.id)

        return setData(copy)

    }, [user])

    const handleChange = data => {
        setStatus('changed')
        setErrors({})
        setData(data)
    }

    const handleSubmit = e => {

        e.preventDefault();

        if(!validate()) return false;

        setStatus('loading');

        save().then(handleSuccess).catch(handleError)
        
    }

    const save = async () => {
        
        try{
            let newUser = { ...data };

            if(data.studentProof instanceof File){
                const fileResponse = await API.upload('/student-proof', data.studentProof);
                newUser.studentProof = fileResponse.data;
            }

            await API.put('/me', newUser);

            return newUser;
        
        }catch(e){

            return e;
        }
    }

    const handleSuccess = newUser => {
        setUser(newUser);
        setStatus('success');
    }

    const handleError = e => {
        console.log(e)
    
        if(e.response?.status === 409){
            setErrors({...errors, email: txt('emailAlreadyUsedError')})
        }
    
        setStatus('error')
    }
    
    const validate = () => {
        let e = {};
    
        if(!Tester.testPhone(data.phone)) 
            e.phone = txt('invalidPhoneError');
    
        if(!Tester.testEmail(data.email)) 
            e.email = txt('invalidEmailError');
    
        if(data.password && !Tester.testPassword(data.password)) 
            e.password = txt('passwordRequirements');
    
        if(data.status?.id === 'etudiant' && !data.studentProof)
            e.studentFile = txt('studentFileRequired');
    
        setErrors(e);
    
        return Object.keys(e).length === 0;
    }

    return (
        <Layout tab='profile' menu='main'>
            {data && <form onSubmit={handleSubmit}>
                <Stack spacing={3} sx={{maxWidth: 700, margin: 'auto', mt: 3}}>
    
                    <Top user={user}/>
    
                    <General
                        user={data}
                        onChange={value => handleChange(value)}
                        errors={errors}
                        show
                        edit
                        hidePhoneCountry
                    />
    
                    <Location
                        user={data}
                        onChange={value => handleChange(value)}
                        errors={errors}
                        show
                    />
    
                    <Pro
                        user={data}
                        onChange={value => handleChange(value)}
                        studentFile={data.studentProof}
                        onStudentFileChange={studentProof => setData({ ...data, studentProof })}
                        errors={errors}
                        show
                    />
    
                    <Checkbox 
                        label={txt('newsletterOptIn')}
                        value={data.newsletter}
                        onChange={e => handleChange({...data, newsletter: e.target.checked})}
                    />
    
                    <Stack spacing={2}>
                        <Toggle 
                            label={txt('changePassword')}
                            value={data.password !== undefined}
                            onChange={(e,v) => handleChange({...data, password: v ? '' : undefined})}
                        />
    
                        {data.password !== undefined &&
                            <Password 
                                value={data.password || ''}
                                onChange={e => handleChange({...data, password: e.target.value})}
                                required
                                helperText={txt('passwordRequirements')}
                                error={errors?.password}
                            />
                        }
                    </Stack>
    
                    <Stack direction='row' justifyContent='flex-end' spacing={3}>
                        {['changed','error'].includes(status) &&
                            <Button variant='outlined' onClick={() => handleChange({...user})}>
                                {txt('cancel')}
                            </Button>
                        }
    
                        <LoadingButton
                            variant='contained'
                            type='submit'
                            loading={statusIs('loading')}
                        >
                            {txt('save')}
                        </LoadingButton>
                    </Stack>
    
                    <Success show={statusIs('success')}>{txt('changesSavedSuccess')}</Success>
    
                    <Error show={statusIs('error')}>{txt('generalError')}</Error>
    
                    <Divider/>
    
                    <Link to='/logout'>
                        <Button color='error'>{txt('logOut')}</Button>
                    </Link>
    
                    <Link to='/profile/delete'>
                        <Button color='error'>{txt('deleteAccount')}</Button>
                    </Link>
                </Stack>
            </form>}
        </Layout>
    );
    
}